
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';

var script = {
  components: {
    PendoIcon
  },
  props: {
    disabled: {
      type: Boolean
    },
    getOptionLabel: {
      type: Function
    },
    inputValue: {
      type: String
    },
    isOpen: {
      type: Boolean
    },
    isPlaceholderVisible: {
      type: Boolean
    },
    isSearchable: {
      type: Boolean
    },
    isSearchIconVisible: {
      type: Boolean
    },
    isSelectedLabelVisible: {
      type: Boolean
    },
    limit: {
      type: Number
    },
    limitText: {
      type: Function
    },
    loading: {
      type: Boolean
    },
    model: {
      type: Array
    },
    placeholder: {
      type: [String, Number]
    },
    removeSelection: {
      type: Function
    },
    selectedLabel: {
      type: [String, Number]
    },
    selectedValue: {
      type: [Object, Number, String, Array]
    },
    shouldAnimateSearchEnterExit: {
      type: Boolean
    },
    toggleMenu: {
      type: Function
    },
    visibleSelectedValues: {
      type: Array
    }
  },
  computed: {
    labelTransition() {
      if (this.shouldAnimateSearchEnterExit) {
        return 'pendo-multiselect-label-slide';
      }

      return '';
    }

  },
  methods: {
    beforeLeave(el) {
      el.style.display = 'none';
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-multiselect__value",
    class: {
      'is-disabled': _vm.disabled
    }
  }, [_vm._t("value", [_vm._l(_vm.visibleSelectedValues, function (option, index) {
    return [_vm._t("tag", [_c('div', {
      key: index,
      staticClass: "pendo-multiselect__tag"
    }, [_c('span', [_vm._v(_vm._s(_vm.getOptionLabel(option)))]), _vm._v(" "), _c('pendo-icon', {
      attrs: {
        "aria-hidden": "true",
        "type": "x",
        "size": "12"
      },
      on: {
        "keydown": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
            return null;
          }

          $event.preventDefault();
          return _vm.removeSelection(option);
        },
        "click": function ($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.removeSelection(option);
        }
      }
    })], 1)], {
      "option": option,
      "inputValue": _vm.inputValue,
      "removeSelection": _vm.removeSelection
    })];
  }), _vm._v(" "), _vm.model && _vm.model.length > _vm.limit ? _c('div', {
    staticClass: "pendo-multiselect__tag"
  }, [_c('span', [_vm._v("+ " + _vm._s(_vm.model.length - _vm.limit))])]) : _vm._e(), _vm._v(" "), _vm.isOpen ? _vm._t("control") : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.labelTransition
    },
    on: {
      "before-leave": _vm.beforeLeave
    }
  }, [_vm.isPlaceholderVisible || _vm.isSelectedLabelVisible ? _c('span', {
    staticClass: "pendo-multiselect__value-inner"
  }, [_vm.isSelectedLabelVisible ? _c('span', {
    staticClass: "pendo-multiselect__selected"
  }, [_vm._t("selectedLabel", [_vm._v("\n                        " + _vm._s(_vm.selectedLabel) + "\n                    ")], null, {
    option: _vm.selectedValue,
    selectedLabel: _vm.selectedLabel
  })], 2) : _vm._e(), _vm._v(" "), _vm.isPlaceholderVisible ? _c('span', {
    staticClass: "pendo-multiselect__placeholder"
  }, [_vm._t("placeholder", [_vm._v("\n                        " + _vm._s(_vm.placeholder) + "\n                    ")], {
    "placeholder": _vm.placeholder
  })], 2) : _vm._e()]) : _vm._e()])], null, {
    selectedLabel: _vm.selectedLabel,
    getOptionLabel: _vm.getOptionLabel,
    inputValue: _vm.inputValue,
    isOpen: _vm.isOpen,
    isPlaceholderVisible: _vm.isPlaceholderVisible,
    isSelectedLabelVisible: _vm.isSelectedLabelVisible,
    limit: _vm.limit,
    limitText: _vm.limitText,
    loading: _vm.loading,
    model: _vm.model,
    placeholder: _vm.placeholder,
    removeSelection: _vm.removeSelection,
    selectedValue: _vm.selectedValue,
    visibleSelectedValues: _vm.visibleSelectedValues,
    toggleMenu: _vm.toggleMenu
  })], 2);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-multiselect-value.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var PendoMultiselectValue = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default PendoMultiselectValue;
